import Home from "../pages/Home/Home";
import Server from "../pages/Product/Server/Server";
import Email from "../pages/Product/Email/Email";
import Login from "../pages/AuthMethod/Login";
import Register from "../pages/AuthMethod/Register";
import Dashboard from "../pages/Dashboard/Dashboard";
import ForgotPassword from "../pages/AuthMethod/ForgotPassword";
import Invoice from "../pages/Invoice/Invoice";
import Recharge from "../pages/TransactionProcess/Recharge";
import Menu from "../pages/TransactionProcess/Menu";
import HistoryRecharge from "../pages/TransactionProcess/HistoryRecharge";
import AddTicket from "../pages/Ticket/AddTicket";
import Order from "../pages/Orders/Order";
import DetailOrder from "../pages/Orders/DetailOrder";
import ProfileForm from "../pages/Profile/Profile";
import Parent from "../pages/Product/Server/Parent";
import Revenue from "../pages/Affiliate/Revenue.js";
import withdrawal from "../pages/Affiliate/ThongKeTienRut";
import success from "../pages/PageStatus/paypal";
import Cart from "../pages/Cart/Cart";
import PaymentProcess from "../pages/PaymentMethods/PaymentProcess";
import ChangePassword from "../pages/Profile/ChangePassword";
import InvoiceDetail from "../pages/Invoice/InvoiceDetail.js";
import Device from "../pages/Profile/Devide";
import ResetPassword from "../pages/AuthMethod/resetPassword";
import Order2 from "../pages/Orders/Order2";
import PaymentBank from "../pages/PaymentMethods/PaymentBank";
import Verify from "../pages/AuthMethod/Verify";
import TicketManagement from "../pages/Ticket/Ticket";
import NeoPayPayment from "../pages/test";
import SuccessNeox from "../pages/PageStatus/success";
import TicketDetail from "../pages/Ticket/TicketDetail.js";
import WebSocket from "../pages/Websocket/websocket.js";
import ParentUpgrade from "../pages/Upgrade/ParentUpgrade.js";
import ThankChangePackage from "../pages/PageStatus/ThankChangePackage.js";
import ThanksDeposit from "../pages/PageStatus/ThanksDeposit.js";
import Parent2 from "../pages/Product/CSHP/parent.js";
import OrderCSHP from "../pages/Product/CSHP/OrderCSHP/OrderCSHP.js";
import OrderDetailCSHP from "../pages/Product/CSHP/OrderCSHP/OrderDetailCSHP.js";
import ParentUpgradeCSHP from "../pages/Product/CSHP/Upgrade/ParentUpgradeCSHP.js";
import InvoiceDetailCSHP from "../pages/Product/CSHP/InvoiceDetailCSHP.js";
import ParentPanel from "../pages/Product/WH Panel/ParentPanel.js";
import OrderPanel from "../pages/Product/WH Panel/OrderPanel/OrderPanel.js";
import OrderDetailPanel from "../pages/Product/WH Panel/OrderPanel/OrderDetailPanel.js";
const publicRoutes = [
    { path: '/register/coupon', component: Register },
    { path: '/register/student', component: Register },
    { path: '/register', component: Register },

    { path: '/', component: Login },
    { path: '/forgotpassword', component: ForgotPassword },
    { path: '/password/reset', component: ResetPassword },
    { path: '/account/verify', component: Verify },


];

// Định nghĩa route riêng tư
const privateRoutes = [

    { path: '/dashboard', component: Dashboard },
    { path: '/invoice', component: Invoice },
    // { path: '/invoice-detail/:invoiceId', component: InvoicePage },
    { path: '/invoice-detail/:invoiceId', component: InvoiceDetail },

    { path: 'cssp/create', component: Parent },
    { path: '/recharge', component: Recharge },
    { path: '/menu', component: Menu },
    { path: '/transaction-list', component: HistoryRecharge },
    { path: '/tickets/add', component: AddTicket },
    { path: '/tickets', component: TicketManagement },
    { path: '/tickets/:id', component: TicketDetail },

    // { path: '/cssp', component: Order },
    { path: '/cssp', component: Order2 },
    { path: '/cssp/server/detail/:orderID', component: DetailOrder },
    { path: '/cssp/server/change-package/:orderID', component: ParentUpgrade },

    { path: 'cshp/create', component: Parent2 },
    { path: 'cshp', component: OrderCSHP },
    { path: '/cshp/server/detail/:orderID', component: OrderDetailCSHP },
    { path: '/cshp/server/change-package/:orderID', component: ParentUpgradeCSHP },
    // { path: '/cshp/server/change-package/:orderID', component: ParentUpgradeCSHP },
    { path: '/cshp/invoice-detail/:invoiceId', component: InvoiceDetailCSHP },

    { path: 'wh-panel/create', component: ParentPanel },
    { path: 'wh-panel', component: OrderPanel },
    { path: 'wh-panel/detail/:orderID', component: OrderDetailPanel },


    { path: '/account/update-info', component: ProfileForm },
    { path: '/account/change-password', component: ChangePassword },
    { path: '/account/device', component: Device },

    { path: '/revenue', component: Revenue },
    { path: '/withdrawal', component: withdrawal },
    { path: '/cart', component: Cart },
    // { path: '/cancel', component: cancel },
    { path: '/thank-you', component: success },
    { path: '/thanks', component: SuccessNeox },

    { path: '/thanh-toan-hoa-don', component: PaymentProcess, showFooter: false, },
    { path: '/thank-you/bank', component: PaymentBank },
    { path: '/thank-you/changepackage', component: ThankChangePackage },
    { path: '/thank-you/recharge', component: ThanksDeposit },

];

// Xuất các route
export { publicRoutes, privateRoutes };
